import { Image } from 'antd';
import RcImage from 'rc-image';
export { RcImage };
export default Image;
